import React from 'react';
import { useState } from 'react';
import styles from './GameGallery.module.scss';
import Image1 from '../../../assets/imgs/CoinbaseHome/carousel_item_1.png';
import Image2 from '../../../assets/imgs/CoinbaseHome/carousel_item_2.png';
import Image3 from '../../../assets/imgs/CoinbaseHome/carousel_item_3.png';
import Image4 from '../../../assets/imgs/CoinbaseHome/carousel_item_4.png';
import Image5 from '../../../assets/imgs/CoinbaseHome/carousel_item_5.png';

import Image1Large from '../../../assets/imgs/CoinbaseHome/carousel_item_1-large.png';
import Image2Large from '../../../assets/imgs/CoinbaseHome/carousel_item_2-large.png';
import Image3Large from '../../../assets/imgs/CoinbaseHome/carousel_item_3-large.png';
import Image4Large from '../../../assets/imgs/CoinbaseHome/carousel_item_4-large.png';
import Image5Large from '../../../assets/imgs/CoinbaseHome/carousel_item_5-large.png';

import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const Collection = [
    {
        id: 1,
        image: Image1,
        imageLarge: Image1Large,
    },
    {
        id: 2,
        image: Image2,
        imageLarge: Image2Large,
    },
    {
        id: 3,
        image: Image3,
        imageLarge: Image3Large,
    },
    {
        id: 4,
        image: Image4,
        imageLarge: Image4Large,
    },
    {
        id: 5,
        image: Image5,
        imageLarge: Image5Large,
    },
];

const GameGallery = () => {
    const [selectedItem, setSelectedItem] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [activeItemIndex, setActiveItemIndex] = useState(0);

    const handleScroll = (id) => {
        let itemId = parseInt(id);
        const imgCollection = document.getElementById('image_collection');
        const imageContainer = document.getElementById('image_container');
        const imageContainerWidth = imageContainer.offsetWidth;
        const imageContainerMarginLeft = parseInt(window.getComputedStyle(imageContainer).getPropertyValue('margin-left'));
        const imageContainerMarginRight = parseInt(window.getComputedStyle(imageContainer).getPropertyValue('margin-right'));

        imgCollection.scrollLeft = (imageContainerWidth + imageContainerMarginLeft + imageContainerMarginRight) * (itemId - 1);
        setSelectedItem(itemId);
    }

    const handleImageGallery = (itemIndex) => {
        setShowModal(true);
        setActiveItemIndex(itemIndex);
    }

    const handleCloseImageModal = () => {
        setShowModal(false);
        setActiveItemIndex(0);
    }

    const handleGalleryNav = (nav) => {
        const collectionLength = Collection.length;

        if (nav > 0) {
            if ((activeItemIndex + 1) === collectionLength) {
                setActiveItemIndex(0);
            } else {
                setActiveItemIndex((index) => index + 1);
            }
        } else {
            if ((activeItemIndex + 1) === 1) {
                setActiveItemIndex(collectionLength - 1);
            } else {
                setActiveItemIndex((index) => index - 1);
            }
        }
    }

    return (
        <div className={styles.game_gallery}>
            <div className={styles.image_collection} id="image_collection">
                {Collection.map((item, index) => (
                    <div className={styles.image_container} key={index} id="image_container">
                        <img src={item.image} alt={item.id} onClick={() => handleImageGallery(index)} />
                    </div>
                ))}
            </div>            

            <div className={styles.indicators}>
                {Collection.map((item, index) => (
                    <div className={`${styles.indicator} ${selectedItem === (index+1) ? styles.selected : ''}`} onClick={() => handleScroll(index+1)} key={index}></div>
                ))}
            </div>

            {showModal && <div>
                <div className={styles.close_btn} onClick={handleCloseImageModal}><FontAwesomeIcon icon={faTimes}/></div>
                <Modal
                    show={showModal}
                    dialogClassName={styles.gallery_modal_dialog}
                    contentClassName={styles.gallery_modal_content}
                    onHide={handleCloseImageModal}
                    centered
                >
                    <Modal.Body className={styles.gallery_modal_body}>
                        <div className={`${styles.nav_btn}`} onClick={() => handleGalleryNav(-1)}></div>
                        <div className={styles.img_container}>
                            <img src={Collection[activeItemIndex].imageLarge} alt="active" />
                        </div>
                        <div className={`${styles.nav_btn} ${styles.right}`} onClick={() => handleGalleryNav(1)}></div>
                    </Modal.Body>
                </Modal>
            </div>}
        </div>
    )
}

export { GameGallery };
